<template>
  <div id="about" class="w1100">
    <div id="nav-header" style="display: flex;justify-content: center">
      <div style="width: 1060px;text-align: left">信息交流与互动 <span class="en-name">USER FEEDBACK</span></div>
    </div>
    <div id="detail-content">

      <div id="left-nav">
        <div id="nav-body">
          <div :class="{'active':showType=='talk','nav-every':true}" @click="changeType('talk')" >
            论坛
          </div>
          <div :class="{'active':showType=='feedBack','nav-every':true}" @click="changeType('feedBack')">
            用户反馈
          </div>
        </div>
      </div>
      <div id="right-content">
        <div id="article-header">

        </div>
        <div style="margin: 10px" v-show="showType=='feedBack'">
          <el-form ref="form" :model="form" label-width="200px"  :rules="rules">
            <el-form-item label="咨询与留言">
              <el-input type="textarea" v-model="form.content" style="width: 400px"></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name" style="width: 400px"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="contact">
              <el-input v-model="form.contact" style="width: 400px"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="form.email" style="width: 400px"></el-input>
            </el-form-item>
            <el-form-item prop="checkCode" label="验证码">
              <el-input v-model="form.checkCode" placeholder="验证码" style="width: 150px"></el-input>&nbsp;&nbsp;
              <img id="codeBox" height="30px" style="vertical-align: middle;" border=0 :src="checkCodeSrc"
                   @click="changeCode" />
            </el-form-item>
            <div style="margin-left: 130px;
                      line-height: 25px;
                      margin-bottom: 20px;">
              <p>信息提示：</p>
              <p>1.请留下真实姓名和电话，以便及时联系回复</p>
              <p>2.遵守中华人民共和国的各项有关法律法规，承担一切因您的行为而直接或间接导致的民事或刑事法律责任</p>
              <p>3.本站管理员有权保留或删除其管辖留言中的任何内容</p>
              <p>4.在此留言即表明您已阅读并接受上述条款</p>
            </div>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">提交</el-button>
              <!--<el-button>取消</el-button>-->
            </el-form-item>
          </el-form>
        </div>
        <div  v-show="showType=='talk'">
          <iframe :src="url"
                  style="width: 900px;min-height: 600px;margin: 0px;padding: 0px;border: 0;overflow-y: hidden"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // 将提交数据转化为formData
  function translateForm(data) {
    var fd = new FormData();
    for (var key in data) {
      fd.append(key, data[key])
    }
    return fd;
  }
  export default {
    name: "about",
    data(){
      return{
        checkCodeSrc:this.GlobalConfig.baseUrl+'/login/login_code.jsp', //验证码Url
        aboutUsContent:'',
        rules: {
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
          contact:[
            { required: true, message: '请输入电话', trigger: 'blur' },
          ],
          email:[
            { required: true, message: '请输入邮箱', trigger: 'blur' },
          ],
          content: [
            { required: true, message: '请填写活动形式', trigger: 'blur' }
          ],
          checkCode:[
            { required: true, message: '请输入验证码', trigger: 'blur' },
          ],
        },
        form: {
          name: '',
          contact: '',
          email: '',
          content: '',
          checkCode:'',
          siteId:"",//站点id
        },
        showType:'talk',
        url:this.targetUrl+"educprocess/courseIframeBBS",//论坛
      }
    },
    methods:{
      changeType(type){
        this.showType = type
      },
      changeCode() {
        let dt=new Date().getTime();
        // document.getElementById('codeBox').src='/login/login_code.jsp?dt='+dt;
        this.checkCodeSrc = this.GlobalConfig.baseUrl+'/login/login_code.jsp?dt='+dt;
        this.form.checkCode = ''; //验证码框置空
      },
      onSubmit() {
        var that = this;
        that.$refs.form.validate((valid) => {
          if (valid) {
            var fd = translateForm(that.form)
            axios.post("/cmsapi/addFeedback", fd).then(function (response) {
              // that.aboutUsContent = response.data.contentString;
              if(response.data=='checkError'){
                that.$message.error('验证码错误！');
              }else if(response.data=='success'){
                that.$message.success('保存成功！');
              }else{
                that.$message.error('保存失败！');
              }
            }).catch(function (error) {
              that.$message.error('保存失败！');
            });
          } else {
            that.$message.error('请填写完整！');
            return false;
          }
        });


      }
    },
    created(){
      axios.post('/cmsapi/getSiteInfo').then(res => {
        this.form.siteId = res.data.id;
      }).catch(error=>{
        console.error(error);
        this.$message.error('网络出现问题，请检查网络！');
      });
    }
  }
</script>


